import React from 'react';
import { classNames } from '../../../../utilities/css.js';
import styles from '../../Stack.scss.js';

/** @deprecated Use LegacyStack or VerticalStack instead. */
function Item({
  children,
  fill
}) {
  if (process.env.NODE_ENV === 'development') {
    // eslint-disable-next-line no-console
    console.warn('Deprecation: <Stack /> is deprecated. This component will be removed in a future major version of Polaris. Use <LegacyStack /> or <VerticalStack /> instead.');
  }

  const className = classNames(styles.Item, fill && styles['Item-fill']);
  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, children);
}

export { Item };
